import { render, staticRenderFns } from "./detail-tab.vue?vue&type=template&id=1726b4fc&scoped=true&"
import script from "./detail-tab.vue?vue&type=script&lang=js&"
export * from "./detail-tab.vue?vue&type=script&lang=js&"
import style0 from "./detail-tab.vue?vue&type=style&index=0&id=1726b4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1726b4fc",
  null
  
)

export default component.exports